
import React from 'react';
import "./styles/About.scss";

/* import { useState } from "react";
import { StackItem } from '@chakra-ui/react'; */




export default function About() {

    
    
 
    return (
        <section className="about">
            <h1>Canto Cuties</h1>
            
            <p>In the Cantoverse, a fantastical world of magic and wonder, there exist 1111 unique anime-style girls known as the Canto Cuties. Each Cutie possesses her own distinct personality, appearance, and backstory.</p>
            <p>These girls come from all corners of the Cantoverse and have various backgrounds and traits. They wear a wide variety of outfits that reflect both the traditional and modern cultures of their homelands, including dresses, suits, armors, and more.</p>
            <p>Despite their diverse backgrounds, the Canto Cuties share a common mission: to spread joy and beauty throughout the Cantoverse.</p>
            <p>Whether you're a collector, a canto enjoyooor, or simply someone who loves beautiful art, there's a Canto Cutie that's perfect for you.
            </p>
        </section> 
    ); 
}
